import { captureMessage, getCurrentScope, setContext, setTag } from '@sentry/gatsby';

const extractMessage = (value) => {
	if (typeof value === 'object' && value !== null && value.message) {
		return value.message;
	}

	if (typeof value === 'string') {
		return value;
	}

	return null;
};

const isPaymentAuthFailure = (message) => {
	return (typeof message === 'string' && message.includes('trouble authorizing the credit card')) || message.includes('card was declined') || message.includes('payment authorization');
};

const getErrorMessage = (event) => {
	const { alert, error, data } = event?.output || {};
	return extractMessage(alert) || extractMessage(error) || extractMessage(data?.error) || extractMessage(data?.alert) || 'Unknown Error';
};

export const sentryReporting = (event, self) => {
	const message = getErrorMessage(event);
	const { headers } = event?.output || {};

	setTag('Pella Component', `${self.src.id}-Machine`);
	setTag('API Transaction ID', headers?.['x-pella-request-id']);
	getCurrentScope().setTransactionName(event.actorId);

	setContext('Error', {
		errorData: JSON.stringify(event) || 'Unknown Error Data',
	});

	captureMessage(message);

	if (isPaymentAuthFailure(message)) {
		captureMessage(message, 'log');
	} else {
		captureMessage(message);
	}
};
